import { render, staticRenderFns } from "./BatchResultManagerTable.vue?vue&type=template&id=361cf78f"
import script from "./BatchResultManagerTable.vue?vue&type=script&lang=js"
export * from "./BatchResultManagerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports